import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/UI/loading";
import { SignOutUser } from "../../store/Auth";

export const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(SignOutUser());
    navigate("/auth/sign_in", { replace: true });
  }, [dispatch, navigate]);

  return <Loading loadingText="Logging Out..." />;
};
